<template>
  <div class="position-relative">
    <CRow class="m-0 unsubscribe-row">
      <CCol
        class="p-0"
        id="bg-img"
        v-if="!IS_DOH_THEME"
      >
        <img v-if="!isAcronymBasedLogin" :src="getBanner" alt="bg" />
        <img
          v-else
          :src="getBanner"
          @error="$event.target.src = '/img/new_home_bg.png'"
          alt="bg"
        />
      </CCol>
      <CCol class="p-0 d-flex align-items-center">
        <CContainer class="unsubscribe-container">
          <CCardGroup
            class="d-flex card-group has-loading-overlay justify-content-center"
          >
            <CCard class="p-4 border-0" style="max-width: 400px">
              <CCardBody>
                <ValidationObserver ref="unsubscribe" v-slot="{ handleSubmit }">
                  <CForm @submit.prevent="handleSubmit(onSubmit)">
                    <div v-if="IS_DOH_THEME" style="text-align: center">
                      <img
                        style="width: 85%"
                        :src="getHeaderLogo"
                        @error="$event.target.src = '/img/doh.png'"
                        alt="logo"
                      />
                    </div>
                    <img
                      id="loginLogo"
                      v-else
                      style="width: 100%"
                      :src="getLoginLogo"
                      @error="$event.target.src = '/img/new_tf_logo.svg'"
                      alt="logo"
                    />
                    <p class="m-3 text-center title font-weight-bold">
                      Want to Unsubscribe?
                    </p>
                    <div>
                      <label class="required">Email Address</label>
                      <div style="min-width: 65%">
                        <ValidationProvider
                          rules="required|email"
                          v-slot="{ errors }"
                        >
                          <TextInput
                            name="email"
                            :value="email"
                            @input="handleInput"
                            :error="errors[0]"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <CRow class="mt-3 mb-4 justify-content-end">
                      <CButton
                        type="button"
                        color="secondary"
                        class="px-3 text-white mr-3"
                        @click="redirectToLogin"
                        >{{ "Cancel" }}</CButton
                      >
                      <CButton
                        type="submit"
                        color="primary"
                        class="px-4 mr-3"
                        >{{ "Unsubscribe" }}</CButton
                      >
                    </CRow>
                  </CForm>
                </ValidationObserver>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CContainer>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TextInput from "@/components/reusable/Fields/TextInput";
import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { LOGIN_URL, IS_DOH_THEME } from "../../helpers/helper";

extend("email", { ...email, message: "Invalid email" });
extend("required", { ...required, message: "This field is mandatory" });
export default {
  name: "Unsubscribe",
  components: {
    TextInput,
  },
  data() {
    return {
      IS_DOH_THEME,
      email: "",
    };
  },
  computed: {
    ...mapGetters(["getImages", "isAcronymBasedLogin"]),
    getBanner() {
      return this.getImages?.banner;
    },
    getHeaderLogo() {
      return this.getImages.header_logo;
    },
    getLoginLogo() {
      return this.getImages.login_logo;
    },
  },
  methods: {
    ...mapActions(["unsubscribe", "showToast", "isEmailBelongsToAcronym"]),
    onUnsubscribe() {
      this.isEmailBelongsToAcronym({username: this.email}).then((res) => {
        if (res.data) {
          this.unsubscribe({ email: this.email });
        }
      });
    },
    redirectToLogin() {
      this.$router.push({ path: LOGIN_URL() });
    },
    handleInput(name, value) {
      this.email = value.toLowerCase();
    },
    async onSubmit() {
      const isValid = await this.$refs.unsubscribe.validate();
      if (!isValid) {
        this.showToast({
          class: "bg-danger text-white",
          message: "please enter a valid email",
        });
        return;
      }
      this.onUnsubscribe();
    },
  },
};
</script>
<style lang="scss" scoped>
// The banner and the form share the screen below the site header (about 95px tall): the banner
// fills its half and is cropped to fit, the form sits in the middle of the other half.
.unsubscribe-row {
  min-height: calc(100vh - 95px);
}
#bg-img {
  max-width: 680px;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
  }
}
@media (max-width: 1000px) {
  #bg-img {
    display: none;
  }
  .unsubscribe-row {
    min-height: auto;
  }
  .position-relative {
    margin-top: 32px;
  }
}

.unsubscribe-container {
  .card-group {
    @media (max-width: 1000px) {
      margin-top: -10px;
    }
    .title {
      font-size: 20px;
      line-height: 28px;
    }
  }
}
</style>
